// Display form of a recorded code revision (email_eval_runs.pipeline_git_sha).
//
// The backend stamps runs started on uncommitted working-tree code with a
// "-dirty" suffix at the END of the 40-char value, so a plain slice(0, n)
// would hide it and the run would look like a clean run of that commit.

const DIRTY_SUFFIX = '-dirty';

export interface GitShaDisplay {
  // Abbreviated sha, or the raw value when it is not a revision ("unknown").
  short: string;
  // True when the run did NOT execute the code at that commit.
  dirty: boolean;
}

export function formatGitSha(value: string, length: number): GitShaDisplay {
  const dirty = value.endsWith(DIRTY_SUFFIX);
  const sha = dirty ? value.slice(0, -DIRTY_SUFFIX.length) : value;
  return { short: sha.slice(0, length), dirty };
}
